import { Draft, produce } from 'immer';
import { Mask } from '@/types';
import { MasksActionTypes, MasksActions } from './types';

const INITIAL_STATE: Mask[] = [];

export const masksReducer = produce((draft: Draft<Mask[]>, action: MasksActions) => {
  switch (action.type) {
    case MasksActionTypes.MASKS_FETCH:
      return action.masks;
    default:
      return draft;
  }
}, INITIAL_STATE);
